import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { fetchOnboardingCompleted, isOnboardingCompleteLocally } from "../utils/onboardingStatus";

/**
 * @returns {{ loading: boolean, needsOnboarding: boolean, refresh: () => void }}
 */
export function useOnboardingStatus() {
  const { userId } = useAuth();
  const locallyComplete = userId ? isOnboardingCompleteLocally(userId) : false;
  const [loading, setLoading] = useState(!!userId && !locallyComplete);
  const [needsOnboarding, setNeedsOnboarding] = useState(false);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      setNeedsOnboarding(false);
      return;
    }
    if (isOnboardingCompleteLocally(userId)) {
      setNeedsOnboarding(false);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    (async () => {
      try {
        const status = await fetchOnboardingCompleted(userId);
        if (!cancelled) setNeedsOnboarding(status === false);
      } catch (e) {
        console.warn("Onboarding status check failed:", e);
        if (!cancelled) setNeedsOnboarding(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [userId, tick]);

  return {
    loading,
    needsOnboarding,
    refresh: () => setTick((t) => t + 1),
  };
}
